import React from "react";

export const PembicaraPosts = () => {
  return (
    <section className="pembicaraDetails-container">
      <p className="pembicaraTitle">Pembicara</p>

      <div className="pembicaraDetails-Row">
        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Matthew, S.Pd., M.Pd.</h2>
          <div className="expertiseInstitusi-title">
            <p>Digital Marketing</p>
            <p>Universitas Surya Kencana</p>
          </div>
          <hr />

          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>

        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Matthew, S.Pd., M.Pd.</h2>
          <div className="expertiseInstitusi-title">
            <p>Digital Marketing</p>
            <p>Universitas Surya Kencana</p>
          </div>
          <hr />

          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>

        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Thomas, S.Si, M.Si</h2>
          <div className="expertiseInstitusi-title">
            <p>Management Skills</p>
            <p>Institusi</p>
          </div>
          <hr />
          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>

        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Kenny, SE.,M.Si</h2>
          <div className="expertiseInstitusi-title">
            <p>Instagram Ads</p>
            <p>Institusi</p>
          </div>
          <hr />
          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>
      </div>

      <div className="pembicaraDetails-Row">
        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Melvern, S.Pd., M.Pd.</h2>
          <div className="expertiseInstitusi-title">
            <p>Accounting</p>
            <p>Institusi</p>
          </div>
          <hr />
          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>

        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Melvern, S.Pd., M.Pd.</h2>
          <div className="expertiseInstitusi-title">
            <p>Accounting</p>
            <p>Institusi</p>
          </div>
          <hr />
          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>

        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Rayhan, S.T.,M.T.</h2>
          <div className="expertiseInstitusi-title">
            <p>Business Branding</p>
            <p>Institusi</p>
          </div>
          <hr />
          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>

        <div className="pembicaraDetails-card">
          <img
            className="pembicaraDetails-cardImage"
            src="http://via.placeholder.com/300"
            alt=""
          />
          <h2>Fahlevy, S.K.M., M.P.H.</h2>
          <div className="expertiseInstitusi-title">
            <p>Strategic Marketing</p>
            <p>Institusi</p>
          </div>
          <hr />
          <div className="pembicara-deskripsi">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis
              earum quidem officiis sint fuga iste aspernatur debitis qui non,
              enim reprehenderit quasi ipsa minima! Dolor asperiores rerum
              repellat ad ratione.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
